import { getSeoKey } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import TermsPage from "components/pages/TermsPage"
import { GetStaticProps } from "next/types"

type TermsOfUseProps = {
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<TermsOfUseProps> = async () => {
  const { data } = await getSeoKey("termsOfUse")
  const seo = {
    title: data.body.title,
    description: data.body.description,
    keywords: data.body.keywords,
  }
  return {
    props: {
      seo: seo,
    },
    revalidate: 60,
  }
}

const TermsOfUse = ({ seo }) => {
  return (
    <>
      <SeoMetaData data={seo} />
      <TermsPage />
    </>
  )
}

export default TermsOfUse
